<template>
  <div class="form_container">
    <div class="form_heading">
        <h2>{{ title }}</h2>
        <woot-button
            class=""
            icon='dismiss'
            variant="clear"
            colorScheme="secondary"
            @click="$emit('onDiscard')"
        />
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
    name: 'FormContainer',
    props:{
        title:{
            type: String,
            default:""
        },
    },
}
</script>

<style lang="scss" scoped>
.form_container{
    max-width: 640px;
    margin: auto;
    margin-top: 32px;
}


.form_heading{
    display: flex;
    align-items: center;
    justify-content: space-between;

    h2{
        font-weight: 600;
        font-size: 20px;
        line-height: 1.4;
        font-family: 'Figtree';
        color: #1F1F1F;
    }
}


</style>